import { render, staticRenderFns } from "./cv-classique.vue?vue&type=template&id=4e37dc7a&scoped=true&"
import script from "./cv-classique.vue?vue&type=script&lang=js&"
export * from "./cv-classique.vue?vue&type=script&lang=js&"
import style0 from "./cv-classique.vue?vue&type=style&index=0&id=4e37dc7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e37dc7a",
  null
  
)

component.options.__file = "cv-classique.vue"
export default component.exports